import { Output, Input, ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base.component';

/**
 * Component.
 */
@Component({
	selector: 'data-protection',
	template: `
		<div class="WidAutoOnMobile White"
			style="background: rgba(255, 255, 255, .2); border-radius: 4px;">
			<div class="EmptyBox5"></div>
			<p style="padding: 0px 10px 0px 10px" class="TexAlCenter">
				<a href="{{'TENANT_SERVER_URL' | env}}/skitbs/public/impressum/contact_de.xhtml" target="_blank" style="color: #fff;">{{v('contact')}}</a>
				| <a href="{{'TENANT_SERVER_URL' | env}}/skitbs/public/impressum/impressum_de.xhtml" target="_blank" style="color: #fff;">{{v('imprint')}}</a>
				| <a href="{{'TENANT_SERVER_URL' | env}}/skitbs/public/impressum/disclaimer_de.xhtml" target="_blank" style="color: #fff;">{{v('disclaimer')}}</a>
				| <a href="{{'TENANT_SERVER_URL' | env}}/skitbs/public/impressum/dataprotection_de.pdf" target="_blank" style="color: #fff;">{{v('dataProtection')}}</a>
				|
			</p>
			<p style="padding: 0px 10px 0px 10px">
				<i class="fa fa-copyright"></i> 2014–2025 food safety qualITy GmbH
					<br /> Alle Rechte vorbehalten.
			</p>
			<p style="padding: 0px 10px 0px 10px">
				Kundenservice<br />
				E-Mail: {{'TENANT_SVC_EMAIL' | env}}<br />
				Telefon: {{'TENANT_SVC_PHONE' | env}}<br />
				Fax: {{'TENANT_SVC_FAX' | env}}
			</p>
			<div class="EmptyBox5"></div>
		</div>
		<div class="EmptyBox10"></div>
		`
})
export class DataProtectionComponent extends BaseComponent {
}

